/* ── STATE (Placeholder arrays until Shopify AJAX Cart is connected) ── */
// let cart = [];
let wishlist = [];

// /* ════ CART DRAWER ════ */
// function openCart() { 
//   document.getElementById('cart-drawer').classList.add('open'); 
//   document.getElementById('drawer-overlay').classList.add('open'); 
//   document.body.style.overflow = 'hidden'; 
//   renderCart(); 
// }

// function closeCart() { 
//   document.getElementById('cart-drawer').classList.remove('open'); 
//   document.getElementById('drawer-overlay').classList.remove('open'); 
//   document.body.style.overflow = ''; 
// }

// function updateCartBadge() {
//   const total = cart.reduce((s, i) => s + (i.qty || 1), 0);
//   const b = document.getElementById('cart-badge');
//   if (b) {
//     b.textContent = total;
//     if (total > 0) {
//       b.classList.add('show');
//     } else {
//       b.classList.remove('show');
//     }
//   }
// }

// function renderCart() {
//   const el = document.getElementById('cart-items');
//   const footer = document.getElementById('cart-footer');
  
//   if (!el || !footer) return;
  
//   if (cart.length === 0) {
//     el.innerHTML = `<div class="cart-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0"/></svg><p>Your cart is empty</p><div class="btn-dark" onclick="closeCart()" style="margin-top:8px; cursor:pointer; padding:10px 20px; display:inline-block;">Continue Shopping</div></div>`;
//     footer.style.display = 'none';
//     return;
//   }
  
//   footer.style.display = 'block';
//   el.innerHTML = cart.map((item, i) => `
//     <div class="cart-item">
//       <div class="cart-item-img">${item.name.split(' ').slice(-1)[0]}<br>${item.num || ''}</div>
//       <div class="cart-item-info">
//         <div class="cart-item-name">${item.name}</div>
//         <div class="cart-item-variant">${item.color} / ${item.size}${item.qty > 1 ? ' × ' + item.qty : ''}</div>
//         <div class="cart-item-price">$${(item.price * (item.qty || 1)).toFixed(2)}</div>
//         <div class="cart-item-remove" onclick="removeFromCart(${i})">Remove</div>
//       </div>
//     </div>`).join('');
    
//   const subtotal = cart.reduce((s, i) => s + i.price * (i.qty || 1), 0);
//   const totalEl = document.getElementById('cart-total');
//   if (totalEl) totalEl.textContent = '$' + subtotal.toFixed(2);
// }

// function removeFromCart(idx) { 
//   cart.splice(idx, 1); 
//   updateCartBadge(); 
//   renderCart(); 
// }

/* ════ WISHLIST DRAWER ════ */
function openWishlist() { 
  document.getElementById('wish-drawer').classList.add('open'); 
  document.getElementById('drawer-overlay').classList.add('open'); 
  document.body.style.overflow = 'hidden'; 
  renderWishlist(); 
}

function closeWishlist() { 
  document.getElementById('wish-drawer').classList.remove('open'); 
  document.getElementById('drawer-overlay').classList.remove('open'); 
  document.body.style.overflow = ''; 
}

function toggleWish(e, id) {
  e.stopPropagation();
  const idx = wishlist.indexOf(id);
  if (idx > -1) { 
    wishlist.splice(idx, 1); 
  } else { 
    wishlist.push(id); 
  }
  
  document.querySelectorAll(`#wish-${id}`).forEach(el => {
    el.textContent = wishlist.includes(id) ? '♥' : '♡';
    el.style.color = wishlist.includes(id) ? '#c0392b' : '';
  });
}

function renderWishlist() {
  const el = document.getElementById('wish-items');
  if (!el) return;
  
  if (wishlist.length === 0) {
    el.innerHTML = `<div class="cart-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg><p>Your wishlist is empty</p></div>`;
    return;
  }
  
  el.innerHTML = wishlist.map(id => {
    return `
    <div class="wish-item">
      <div class="wish-item-info">
        <div class="wish-item-name">Product ID: ${id}</div>
        <div class="wish-item-atc" onclick="closeWishlist()">View Product</div>
      </div>
    </div>`;
  }).join('');
}

function closeAllDrawers() { 
  // closeCart(); 
  closeWishlist(); 
}

// /* ════ SEARCH OVERLAY ════ */
// function openSearch() {
//   const el = document.getElementById('search-drawer');
//   if (!el) {
//     console.error('search-drawer not found');
//     return;
//   }

//   el.classList.add('open');
//   document.getElementById('drawer-overlay')?.classList.add('open');
//   document.body.style.overflow = 'hidden';
// }function closeSearch() {
//   const el = document.getElementById('search-drawer');
//   if (el) el.classList.remove('open');

//   document.getElementById('drawer-overlay')?.classList.remove('open');
//   document.body.style.overflow = '';
// }

/* ════ TOAST NOTIFICATIONS ════ */
function showToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  
  t.textContent = '✓ ' + msg + ' — Added to Cart';
  t.style.transform = 'translateX(-50%) translateY(0)';
  
  clearTimeout(t._to);
  t._to = setTimeout(() => {
    t.style.transform = 'translateX(-50%) translateY(80px)';
  }, 2600);
}

/* ════ POLICY MODAL ════ */
const POLS = {
  terms: { ey: 'Legal', ttl: 'Terms of Service', body: '<p style="margin-bottom:24px">By purchasing from liftapparelofficial.com you agree to these terms. Governed by Florida law.</p><p>Questions? <a href="mailto:info@liftapparelofficial.com" style="color:var(--dark);border-bottom:1px solid">info@liftapparelofficial.com</a></p>' },
  privacy: { ey: 'Legal', ttl: 'Privacy Policy', body: '<p style="margin-bottom:24px">We collect only what is needed to fulfill your order. We do not sell your data.</p><p>Questions? <a href="mailto:info@liftapparelofficial.com" style="color:var(--dark);border-bottom:1px solid">info@liftapparelofficial.com</a></p>' },
  shipping: { ey: 'Help', ttl: 'Shipping Policy', body: '<p style="margin-bottom:16px"><strong>Processing:</strong> 2–3 business days.</p><p style="margin-bottom:16px"><strong>Shipping:</strong> Standard 5–8 business days after dispatch.</p><p>Questions? <a href="mailto:info@liftapparelofficial.com" style="color:var(--dark);border-bottom:1px solid">info@liftapparelofficial.com</a></p>' },
  refund: { ey: 'Help', ttl: 'Refund Policy', body: '<p style="margin-bottom:16px">Returns accepted within <strong>14 days</strong> of delivery. Items must be unworn with tags. Sale items are final sale.</p><p>Email <a href="mailto:info@liftapparelofficial.com" style="color:var(--dark);border-bottom:1px solid">info@liftapparelofficial.com</a> with your order number.</p>' }
};

function openPol(k) {
  const d = POLS[k];
  if (!d) return;
  
  document.getElementById('pol-ey').textContent = d.ey;
  document.getElementById('pol-ttl').textContent = d.ttl;
  document.getElementById('pol-body').innerHTML = d.body;
  
  const modal = document.getElementById('pol-modal');
  if (modal) {
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }
}

function closePol() {
  const modal = document.getElementById('pol-modal');
  if (modal) {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }
}

/* ════ GLOBAL EVENT LISTENERS ════ */
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    closeSearch();
    closePol();
    closeCart();
    closeWishlist();
  }
});